module.exports = __webpack_public_path__ + "static/img/payd.3bc30f6e.png";